module.exports = __webpack_public_path__ + "static/media/NBCU.7b3ea40b.png";